<template>
  <div>
    <Form ref="addModel" :model="addModel" :rules="ruleValidate" :label-width="100">
      <FormItem label="设备名称" prop="clientName">
        <Input v-model="addModel.clientName"></Input>
      </FormItem>
      <FormItem label="设备类型" prop="clientType">
        <Input v-model="addModel.clientType"></Input>
      </FormItem>

      <FormItem label="产品类型" prop="projectId">
        <Select v-model="addModel.projectId" @on-change="projectChange" :label-in-value="true">
          <Option
            v-for="(item, index) in clientSelect"
            :value="item.dictionaryID"
            :key="index"
          >{{ item.dictionaryValue }}</Option>
        </Select>
      </FormItem>

      <FormItem label="所属主设备" prop="clientID">
        <Select v-model="addModel.clientID">
          <Option
            v-for="(item, index) in clientList"
            :value="item.clientID"
            :key="index"
          >{{ item.clientName }}</Option>
        </Select>
      </FormItem>

      <!-- <FormItem label="所属机构" prop="organName">
        <Button type="primary" @click="treeModel=true">选择机构</Button>
        <span class="ml-5">{{addModel.organName}}</span>
      </FormItem> -->

      <FormItem label="描述信息">
        <Input
          v-model="addModel.clientDescription"
          type="textarea"
          :autosize="{minRows: 2,maxRows: 5}"
        ></Input>
      </FormItem>
    </Form>
    <div class="text-center modal-foter">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('addModel')">确 定</Button>
    </div>

    <!-- <Modal v-model="treeModel" title="选择机构">
      <organTree @selectTreeData="selectTreeData"></organTree>
    </Modal> -->
  </div>
</template>
<script>
import organTree from "../../basedata/organ/organTree.vue";
export default {
  components: { organTree },
  data: function () {
    return {
      treeModel: false,
      organParentName: "",
      addModel: {
        clientID: "",
        clientName: "",
        clientType: "",
        clientDescription: "",
        organID: "",
        organName: "",
        projectId: "",
        projectName: "",
      },
      clientList: [],
      clientSelect: [],
      ruleValidate: {
        clientName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        clientType: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        // organName: [
        //   {
        //     required: true,
        //     message: "不能为空",
        //   },
        // ],
        projectId: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        clientID: [
          {
            required: true,
            message: "不能为空",
          },
        ],
      },
    };
  },

  created: function () {
    this.$common.getDictionary("产品").then((data) => {
      this.clientSelect = data;
    });
    this.getclientList();
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },

    getclientList() {
      this.$api.get("client/getListAll").then((rsp) => {
        if (rsp != false) {
          this.clientList = rsp.data;
          console.log('hfsdih',this.clientList);
        }
      });
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          this.$api.post("clientDetail/create", this.addModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("添加成功");
              this.returnBack();
              this.resetData();
              this.$emit("loadData");
            }
          });
        }
      });
    },

    resetData() {
      for (let key in this.addModel) {
        this.addModel[key] = "";
      }
      this.$refs["addModel"].resetFields();
    },
    selectTreeData: function (data) {
      this.addModel.organID = data[0].organID;
      this.addModel.organName = data[0].title;
    },
    projectChange(data) {
      this.addModel.projectName = data.label;
    },
  },
};
</script>
<style scoped>
</style>